import { Directive, HostBinding } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../util/popover-ref";
export class PopoverArrowGapDirective {
    constructor(cd, popoverRef) {
        var _a;
        this.cd = cd;
        this.popoverRef = popoverRef;
        this.destroy$ = new Subject();
        this.arrowSize = (_a = this.popoverRef.config.arrowSize) !== null && _a !== void 0 ? _a : 0;
        this.popoverRef
            .positionChanges()
            .pipe(takeUntil(this.destroy$))
            .subscribe((p) => {
            const { offsetX = 0, offsetY = 0, panelClass } = p.connectionPair;
            const horzPlacemnet = panelClass === null || panelClass === void 0 ? void 0 : panelClass.includes('horz');
            this.calcGapOffset(offsetX, offsetY, horzPlacemnet);
            this.cd.detectChanges();
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    calcGapOffset(x, y, horzPlacemnet = false) {
        if (!horzPlacemnet) {
            this.offsetTop = y >= 0 ? y * -1 : null;
            this.offsetBottom = y < 0 ? y - 1 + 1 : null;
            this.offsetLeft = x < 0 ? x * -1 : null;
            this.offsetRight = x >= 0 ? x : null;
        }
        else {
            this.offsetTop = y < 0 ? y * -1 : null;
            this.offsetBottom = y >= 0 ? y : null;
            this.offsetLeft = x >= 0 ? x * -1 : null;
            this.offsetRight = x < 0 ? x - 1 + 1 : null;
        }
    }
}
PopoverArrowGapDirective.ɵfac = function PopoverArrowGapDirective_Factory(t) { return new (t || PopoverArrowGapDirective)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.PopoverRef)); };
PopoverArrowGapDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PopoverArrowGapDirective, selectors: [["", "mhePopoverArrowGap", ""]], hostVars: 12, hostBindings: function PopoverArrowGapDirective_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵstyleProp("width", ctx.arrowSize, "px")("height", ctx.arrowSize, "px")("top", ctx.offsetTop, "px")("right", ctx.offsetRight, "px")("bottom", ctx.offsetBottom, "px")("left", ctx.offsetLeft, "px");
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverArrowGapDirective, [{
        type: Directive,
        args: [{ selector: '[mhePopoverArrowGap]' }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.PopoverRef }]; }, { arrowSize: [{
            type: HostBinding,
            args: ['style.width.px']
        }, {
            type: HostBinding,
            args: ['style.height.px']
        }], offsetTop: [{
            type: HostBinding,
            args: ['style.top.px']
        }], offsetRight: [{
            type: HostBinding,
            args: ['style.right.px']
        }], offsetBottom: [{
            type: HostBinding,
            args: ['style.bottom.px']
        }], offsetLeft: [{
            type: HostBinding,
            args: ['style.left.px']
        }] }); })();
